import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eb7bdab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tai-khoan-selection__fields" }
const _hoisted_2 = { class: "tai-khoan-selection__codes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'tai-khoan-selection',
      _ctx.orientation === 'vertical'
        ? 'tai-khoan-selection--vertical'
        : 'tai-khoan-selection--horizontal',
      { 'tai-khoan-selection--readonly': _ctx.readOnly },
    ])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createBlock(_component_LabelCustom, {
          key: 0,
          class: _normalizeClass(['tai-khoan-selection__label', _ctx.labelClasses]),
          "is-bolder": _ctx.isBolder,
          "is-text-muted": _ctx.isTextMuted,
          "is-required": _ctx.isRequiredComputed
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }, 8, ["class", "is-bolder", "is-text-muted", "is-required"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_autocomplete, {
          id: `${_ctx.id}_tai-khoan`,
          ref: "maTaiKhoanInputRef",
          class: "tai-khoan-selection__input tai-khoan-selection__input--matk",
          disabled: _ctx.readOnly || _ctx.disableMaTaiKhoanProp,
          tabindex: _ctx.startTabIndex,
          placeholder: _ctx.readOnly ? '' : 'Mã tài khoản',
          "value-key": "value",
          modelValue: _ctx.maTaiKhoanDangChon,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.maTaiKhoanDangChon) = $event)),
          "trigger-on-focus": false,
          "popper-append-to-body": false,
          "fetch-suggestions": _ctx.queryTaiKhoan,
          "highlight-first-item": true,
          clearable: "",
          onSelect: _ctx.onSelectTaiKhoan,
          onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select())),
          onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.iconClickedHandler('tai_khoan')))
        }, {
          default: _withCtx(({ item }) => [
            (item.is_sentinel)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "tai-khoan-selection__sentinel",
                  onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                }, _toDisplayString(item.ten_tai_khoan), 33))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(item.ma_tai_khoan), 1)
                  ]),
                  _createElementVNode("span", null, " - " + _toDisplayString(item.ten_tai_khoan), 1)
                ], 64))
          ]),
          _: 1
        }, 8, ["id", "disabled", "tabindex", "placeholder", "modelValue", "fetch-suggestions", "onSelect"]),
        _createVNode(_component_el_autocomplete, {
          id: `${_ctx.id}_chi-tiet`,
          ref: "maChiTietInputRef",
          class: "tai-khoan-selection__input tai-khoan-selection__input--mact",
          modelValue: _ctx.maChiTietDangChon,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.maChiTietDangChon) = $event)),
          "value-key": "value",
          placeholder: _ctx.maChiTietPlaceholder,
          "trigger-on-focus": false,
          "popper-append-to-body": false,
          "fetch-suggestions": _ctx.queryThongTinChiTiet,
          "highlight-first-item": true,
          tabindex: _ctx.startTabIndex != null ? _ctx.startTabIndex + 1 : undefined,
          disabled: _ctx.isInputTaiKhoanChiTietDisabled || _ctx.readOnly,
          clearable: "",
          onSelect: _ctx.onSelectTaiKhoanChiTiet,
          onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select())),
          onClear: _cache[7] || (_cache[7] = ($event: any) => (_ctx.iconClickedHandler('chi_tiet')))
        }, {
          default: _withCtx(({ item }) => [
            (item.is_sentinel)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "tai-khoan-selection__sentinel",
                  onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                }, _toDisplayString(item.ten_tai_khoan), 33))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(item.ma_tai_khoan) + " / " + _toDisplayString(item.ma_chi_tiet), 1)
                  ]),
                  _createElementVNode("span", null, " - " + _toDisplayString(item.ten_tai_khoan), 1)
                ], 64))
          ]),
          _: 1
        }, 8, ["id", "modelValue", "placeholder", "fetch-suggestions", "tabindex", "disabled", "onSelect"])
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["tai-khoan-selection__tentk", { 'tai-khoan-selection__tentk--empty': !_ctx.tenTaiKhoan }])
      }, _toDisplayString(_ctx.tenTaiKhoan || (_ctx.readOnly ? "" : "Tên tài khoản")), 3)
    ])
  ], 2))
}